import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import "./header.scss";
import { LinkIconConfig, RouterConfig } from '../../../config';
import { Link, NavLink } from 'react-router-dom';
import { useWindowSize } from '../../../useHooks/useWindowSize';

const dataWhenScreenmobile = [
    {
        id: 1,
        title: RouterConfig.policy.name,
        item: [
            { text: RouterConfig.policy.private.name, linkTo: RouterConfig.policy.private.route },
            { text: RouterConfig.policy.useContent.name, linkTo: RouterConfig.policy.useContent.route },
        ],
    },
    {
        id: 2,
        title: RouterConfig.rules.name,
        item: [
            { text: RouterConfig.rules.introduce.name, linkTo: RouterConfig.rules.introduce.route },
            { text: RouterConfig.rules.explainWords.name, linkTo: RouterConfig.rules.explainWords.route },
            { text: RouterConfig.rules.generalTerms.name, linkTo: RouterConfig.rules.generalTerms.route },
            { text: RouterConfig.rules.detailedTerms.name, linkTo: RouterConfig.rules.detailedTerms.route },
        ],
    },
    {
        id: 3,
        title: 'Lịch sử cập nhật',
    },

]
const Header = ({ onChange }) => {
    const windowSize = useWindowSize()
    const [opent, setOpent] = useState(false)
    const handleOpent = () => {
        setOpent(!opent)
    }
    const handleActive = () => {
        setOpent(false)
    }
    useEffect(() => {
        onChange && onChange(opent)
    }, [opent])

    useEffect(() => {
        if (windowSize?.width > 991 && opent) {
            setOpent(false)
        }
    }, [windowSize?.width,opent])

    const Horizontal = () => <div className='horizontalLineHeader' />
    return (
        <div className='header'>
            <div className='iconLogo'>
                <a href="https://map.map4d.vn/">
                    <img src={LinkIconConfig.logo} />
                </a>
            </div>
            <div className='navbarToggler' onClick={handleOpent}>
                {
                    opent
                        ? <img src={LinkIconConfig.headers.close} /> : <img src={LinkIconConfig.headers.toggler} />
                }

            </div>

            {
                opent &&
                <div className='headerMenuMobile'>
                    {
                        dataWhenScreenmobile.map((value, index) => {
                            return (
                                <div key={value.id} className="wrap">
                                    <div className='title'>{value.title}</div>
                                    <>
                                        {
                                            (index) < dataWhenScreenmobile.length - 1 && <Horizontal />
                                        }
                                    </>
                                    {
                                        value?.item?.length > 0 &&
                                        <>
                                            {
                                                value?.item?.map((it, i) => {
                                                    return (
                                                        <div key={it + i} className="wrapItem" onClick={handleActive}>
                                                            <NavLink
                                                                to={it.linkTo}
                                                                className={({ isActive }) =>
                                                                    isActive ? 'activeClassName' : undefined
                                                                }
                                                            >
                                                                <div className='item'>{it.text}</div>
                                                            </NavLink>

                                                            <Horizontal />
                                                        </div>
                                                    )
                                                })
                                            }
                                        </>
                                    }

                                </div>
                            )
                        })
                    }
                </div>
            }
        </div>
    );
};

Header.propTypes = {

};

export default Header;